const determineHost = () => {
	// 👇 because: https://stackoverflow.com/a/70504910/3633109
	// ie, staging-and-preview-web
	if (
		process.env.NEXT_PUBLIC_VERCEL_URL &&
		!process.env.NEXT_PUBLIC_VERCEL_URL.startsWith('production')
	) {
		if (
			process.env.NEXT_PUBLIC_VERCEL_URL ===
			'staging-and-preview-web.vercel.app'
		) {
			return 'https://staging.metmuseum.org';
		} else {
			return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
		}
	}

	if (process.env.NODE_ENV === 'development') {
		return 'http://localhost:3000';
	}

	// production
	return 'https://www.metmuseum.org';
};

export const HOST = determineHost();
export const APP_NAME =
	process.env.NODE_ENV === 'development'
		? 'met-js-web-development'
		: process.env.APP_NAME || 'met-js-web'; // this is used to identify the app for NewRelic, but could be used for anything else that needs it

// Go API
const COLLECTION_API_GO_BASE_URL =
	process.env.COLLECTION_API_GO_BASE_URL ||
	'https://collectionapi.metmuseum.org';
export const COLLECTION_API_OBJECT_ENDPOINT = `${COLLECTION_API_GO_BASE_URL}/api/collection/v1/object`; // "Ron's API" good but not comprehensive
export const COLLECTION_API_OBJECT_PAGE_ENDPOINT = `${COLLECTION_API_GO_BASE_URL}/private/collection/v2/objectPage`; // API for object pages, has complete object data
export const COLLECTION_API_OBJECT_PAGE_TRANSLATIONS_INDEX_ENDPOINT = `${COLLECTION_API_OBJECT_PAGE_ENDPOINT}/translations/index`;
export const COLLECTION_API_SEARCH = `${COLLECTION_API_GO_BASE_URL}/public/collection/v1/search`;

// GraphQL API
const COLLECTION_API_GRAPHQL_BASE_URL =
	process.env.COLLECTION_API_GRAPHQL_BASE_URL ||
	'https://collectionapi.metmuseum.org';
export const COLLECTION_GRAPHQL_URL = `${COLLECTION_API_GRAPHQL_BASE_URL}/graphql`;
export const GALLERY_API_URL =
	'https://www3.metmuseum.org/rodan/location-info/gallery';
export const STUDYCENTER_API_URL =
	'https://www3.metmuseum.org/rodan/study-center/object';
export const FLATLAND_BASE_URL =
	process.env.FLATLAND_BASE_URL || 'http://flatland-seven.vercel.app';
export const LAUDER_COLLECTION_ID = 268;

// VNTANA API
export const VNTANA_API_BASE_URL = 'https://api-platform.vntana.com';
export const VNTANA_PUBLIC_API_BASE_URL = 'https://api.vntana.com';
export const VNTANA_EMBED_BASE_URL = 'https://embed.vntana.com';
export const VNTANA_ORGANIZATION_UUID = 'bf18f709-bbd2-4bad-9cbc-08b392b1977e';
export const VNTANA_CLIENT_UUID = '148424d8-b480-4d93-a38c-afc73f2cbf76';
export const VNTANA_ORGANIZATION_SLUG = 'The-Metropolitan-Museum-of-Art';

export const SANITY_API_TOKEN = process.env.SANITY_API_TOKEN || 'testing token';
export const SANITY_API_VERSION =
	process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-12-20';
export const SANITY_DATASET = process.env.NEXT_PUBLIC_SANITY_DATASET;
export const SANITY_PROJECT_ID =
	process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'cctd4ker';
export const OVERLY_SIMPLE_API_AUTH_TOKEN =
	process.env.OVERLY_SIMPLE_API_AUTH_TOKEN || 'testing token';
export const CURRENT_YEAR = new Date().getFullYear();
export const IMPERVA_SAFELIST_SECRET =
	process.env.COLLECTION_API_SAFELIST_SECRET;
export const NYC_IANA_TIMEZONE = 'America/New_York'; // 🇺🇸 🗽
export const SUPPORTED_LANGUAGES = [
	{ id: 'en', name: 'English', localName: 'English' },
	{ id: 'es', name: 'Spanish', localName: 'Español' },
	{ id: 'pt', name: 'Portugese', localName: 'Português' },
	{ id: 'fr', name: 'French', localName: 'Français' },
	{ id: 'it', name: 'Italian', localName: 'Italiano' },
	{ id: 'de', name: 'German', localName: 'Deutsch' },
	{ id: 'ja', name: 'Japanese', localName: '日本語' },
	{ id: 'ko', name: 'Korean', localName: '한국어' },
	{ id: 'zh', name: 'Chinese', localName: '中文 (简体)' },
	{ id: 'ru', name: 'Russian', localName: 'Pусский' },
];
export const SUPPORTED_LOCALES = SUPPORTED_LANGUAGES.map(
	(language) => language.id,
);
export const SITE_SEARCH_PER_PAGE = 10;
export const CONSERVATION_OUR_WORK =
	'/about-the-met/conservation-and-scientific-research/projects';
export const CONSERVATION_OUR_HISTORY =
	'/about-the-met/conservation-and-scientific-research/conservation-stories/history-of-conservation';
export const ABOUT_THE_MET_TITLE = 'About The Met';
export const ABOUT_THE_MET = '/about-the-met';
export const NO_IMAGE_AVAILABLE =
	'/content/img/placeholders/NoImageAvailableIcon.png';
export const NO_IMAGE_AVAILABLE_534 =
	'/content/img/placeholders/noimage534x534.png';
export const MET_FIFTH_BUILDING_ID = '4f2f91fd-1bbe-46b2-a392-addb41d5a27f';
export const CLOISTERS_BUILDING_ID = '3e6a0afc-79ec-4686-81f0-ad920202ba4f';
export const CCS_DEPARTMENTS_TITLE = 'Departments';
/*
	The Research at The Met hub. Not /research, which is still gated behind
	FEATURE_FLAG_SHOW_LIBRARY_DEPARTMENTS with no published landing page document.
*/
export const RESEARCH_AT_THE_MET = '/hubs/research-at-the-met';
export const RESEARCH_AT_THE_MET_TITLE = 'Research at The Met';
export const ONE_HOUR_IN_SECONDS = 3_600;
export const ONE_DAY_IN_SECONDS = 86_400;
export const ONE_MONTH_IN_SECONDS = 2_628_000;
export const DEPARTMENT_TYPE_CURATORIAL = 'curatorial';
export const DEPARTMENT_TYPE_CONSERVATION = 'conservation';
export const DEPARTMENT_TYPE_LIBRARY = 'library';
export const DEPARTMENT_TYPE_ARCHIVES = 'archives';
export const DEPARTMENT_TYPE_RESEARCH_CENTER = 'research-center';

//TODO find a sane way to share with SASS and/or CSS.
export const BREAKPOINT_M = 960;
export const BREAKPOINT_S = 500;
